module.exports = __webpack_public_path__ + "./images/cdfa31807f2f23b245aeb8418b98cd65.jpg";